__turbopack_context__.v({
  "bgFilter": "QSKlhG_bgFilter",
  "divider": "QSKlhG_divider",
  "dividerHorizontal": "QSKlhG_dividerHorizontal",
  "dot": "QSKlhG_dot",
  "fadeIn": "QSKlhG_fadeIn",
  "fadeInOpacity": "QSKlhG_fadeInOpacity",
  "fadeOut": "QSKlhG_fadeOut",
  "fadeOutOpacity": "QSKlhG_fadeOutOpacity",
  "finished": "QSKlhG_finished",
  "heroHeading": "QSKlhG_heroHeading",
  "imageWrapper": "QSKlhG_imageWrapper",
  "line1": "QSKlhG_line1",
  "line2": "QSKlhG_line2",
  "line3": "QSKlhG_line3",
  "line4": "QSKlhG_line4",
  "mxLg": "QSKlhG_mxLg",
  "playing": "QSKlhG_playing",
  "tabBalance": "QSKlhG_tabBalance",
  "tabPostpartum": "QSKlhG_tabPostpartum",
  "tabWomen": "QSKlhG_tabWomen",
  "wrapper": "QSKlhG_wrapper",
});
